import * as types from '../../lib/actionTypes.es6';

export function getGatewayConfigsRequest(partner) {
  return { type: types.GET_GATEWAY_CONFIGS_REQUEST, payload: partner };
}
export function getGatewayConfigsSuccess(configs) {
  return { type: types.GET_GATEWAY_CONFIGS_SUCCESS, payload: configs };
}
export function getGatewayConfigsFail(error) {
  return { type: types.GET_GATEWAY_CONFIGS_FAIL, payload: error };
}

export function getGatewayConfigRawRequest(partner, id) {
  return { type: types.GET_GATEWAY_CONFIG_RAW_REQUEST, payload: { partner, id } };
}
export function getGatewayConfigRawSuccess(raw) {
  return { type: types.GET_GATEWAY_CONFIG_RAW_SUCCESS, payload: raw };
}
export function getGatewayConfigRawFail(error) {
  return { type: types.GET_GATEWAY_CONFIG_RAW_FAIL, payload: error };
}
export function getGatewayConfigRawReset() {
  return { type: types.GET_GATEWAY_CONFIG_RAW_RESET };
}

export function publishGatewayConfigRequest(partner, id, rawYaml) {
  return { type: types.PUBLISH_GATEWAY_CONFIG_REQUEST, payload: { partner, id, rawYaml } };
}
export function publishGatewayConfigSuccess(result) {
  return { type: types.PUBLISH_GATEWAY_CONFIG_SUCCESS, payload: result };
}
export function publishGatewayConfigFail(error) {
  return { type: types.PUBLISH_GATEWAY_CONFIG_FAIL, payload: error };
}
export function publishGatewayConfigReset() {
  return { type: types.PUBLISH_GATEWAY_CONFIG_RESET };
}

export function createGatewayConfigRequest(partner, rawYaml) {
  return { type: types.CREATE_GATEWAY_CONFIG_REQUEST, payload: { partner, rawYaml } };
}
export function createGatewayConfigSuccess(result) {
  return { type: types.CREATE_GATEWAY_CONFIG_SUCCESS, payload: result };
}
export function createGatewayConfigFail(error) {
  return { type: types.CREATE_GATEWAY_CONFIG_FAIL, payload: error };
}
export function createGatewayConfigReset() {
  return { type: types.CREATE_GATEWAY_CONFIG_RESET };
}
